// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__QGOF9","web_layout":"styles_web_layout__cKRG7"};